module.exports = __webpack_public_path__ + "img/wa-status-ok.094899fe.svg";